var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank",attrs:{"id":"content"}},[_c('div',{staticClass:"content full hide-scrollbar"})])
}]

export { render, staticRenderFns }